import React from 'react';

interface SkeletonProps {
  className?: string;
}

/** Skeleton with shimmer effect - use for loading states (Standard SaaS pattern) */
const Skeleton: React.FC<SkeletonProps> = ({ className = '' }) => (
  <div className={`relative overflow-hidden bg-gray-100 rounded-md ${className}`}>
    <div className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent" />
  </div>
);

export default Skeleton;
